var app = angular.module("leonardo");

var LevelsActionsController = function($scope, $state, countryObj, parentObj, AuthDataService) {

  $scope.authDataService = AuthDataService;
  $scope.countryObj = countryObj;
  $scope.parentObj = parentObj;

  $scope.getLevelType = function () {
    if (!$scope.countryObj) return '';
    var label = 'level_';
    var levelType = 1;
    if ($scope.parentObj) {
      levelType += parseInt($scope.parentObj.level_type);
    }
    label += levelType + '_label';
    return $scope.countryObj[label];
  };

};

app.controller('LevelsActionsController', ['$scope', '$state', 'countryObj', 'parentObj', 'AuthDataService',
  LevelsActionsController]);
